import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    ApiModel,
    BulkUploadDraftSellerModel,
    BulkUploadDraftSellerModelConverter,
    ListingSellerDraftModel,
    Timestamp,
} from '@steelbuy/ts-shared';
import { DRAFT_BULK_UPLOAD_KEY } from './createBulkUpload';
import axios from '../../axios';

export type UpdateDraftBulkUploadRequest = Pick<BulkUploadDraftSellerModel, 'bulkId' | 'bulkDraftReferenceId'> & {
    bulkListingDraftsUpdates?: ListingSellerDraftModel[];
    deletedListingDrafts?: BulkUploadDraftSellerModel['bulkId'][];
    autoRenew?: boolean;
    expireDate?: Timestamp['value'];
    isSubmission?: boolean;
};

const updateDraftBulkUpload = async (request: UpdateDraftBulkUploadRequest) => {
    const { isSubmission, ...payload } = request;
    const apiRoute = isSubmission ? 'seller' : 'universal';
    const requestType = isSubmission ? 'submission' : 'update';
    const { data } = await axios.put<BulkUploadDraftSellerModel>(
        `/api/${apiRoute}/bulk-listing-drafts/${requestType}`,
        payload
    );
    const modelConverter = new BulkUploadDraftSellerModelConverter();
    const convertedData = modelConverter.toViewModel(data as unknown as ApiModel<BulkUploadDraftSellerModel>);
    return convertedData;
};

export const useUpdateBulkUpload = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (request: UpdateDraftBulkUploadRequest) => updateDraftBulkUpload(request),
        onSuccess: (data: BulkUploadDraftSellerModel) => {
            queryClient.setQueryData([DRAFT_BULK_UPLOAD_KEY, data.bulkId], data);
        },
    });
};
